import { createContextKey } from '@opentelemetry/api';

export const spanIdKey: any = createContextKey('spanId');
